import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  AppApis,
  PlatformTerminologyConceptQuery,
} from '@app/core/APIs/app-apis';
import type {
  TerminologyConceptCatalog,
  TerminologyConceptDetail,
} from './terminology-concept-catalog.models';

const options = {
  withCredentials: true,
  headers: new HttpHeaders({
    'skip-error-interceptor': 'yes',
    'skip-loading-interceptor': 'yes',
  }),
};

@Injectable({ providedIn: 'root' })
export class TerminologyConceptCatalogService {
  private readonly http = inject(HttpClient);
  private readonly apis = inject(AppApis);

  search(query: PlatformTerminologyConceptQuery) {
    return this.http.get<TerminologyConceptCatalog>(
      this.apis.core.manual.getPlatformTerminologyConcepts(query),
      options,
    );
  }

  definition(definitionId: number, query: PlatformTerminologyConceptQuery) {
    return this.http.get<TerminologyConceptDetail>(
      this.apis.core.manual.getPlatformTerminologyConcept(definitionId, query),
      options,
    );
  }
}
